module.exports = __webpack_public_path__ + "static/media/25.3ab438ac.JPG";